import { ServiceOneData } from "@/data";
import Link from "@/components/link";
import React from "react";
import Img from "@/components/img";
import SwiperCore, { Autoplay, Thumbs, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Autoplay, Thumbs, Navigation]);

const ServiceOne = () => {
  const { title, posts } = ServiceOneData;

  const serviceSwiperOptions = {
    slidesPerView: 3, 
    spaceBetween: 27, 
    loop: false, 
    speed: 1000, 
    navigation: {
      nextEl: "#service-slide-next",
      prevEl: "#service-slide-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3, 
      },
      576: {
        slidesPerView: 1, 
      },
    },
  };

  return (
    <section className="service_area section_padding">
      <div className="container">
        <div className="hero-section-title text-center">
          <h1>{title}</h1>
        </div>
        <Swiper {...serviceSwiperOptions} className="service_slider">
          {posts.map(({ image, title, text, button }, index) => (
            <SwiperSlide key={`service-one-key-${index}`}>
              <div className="service_box">
                <div className="service_img">
                  <Img src={image} alt={title} className="img-fluid" />
                </div>
                <div className="service_details">
                  <Link href={button.url}>
                    <h2>{title}</h2>
                  </Link>
                  <p>{text}</p>
                  <Link href={button.url} className="btn-blue">
                    {button.label}
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-button-prev" id="service-slide-prev">
            <i className="fa fa-angle-left"></i>
          </div>
          <div className="swiper-button-next" id="service-slide-next">
            <i className="fa fa-angle-right"></i>
          </div>
        </Swiper>
      </div>
    </section>

    // <section className="service_area section_padding">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-md-12">
    //         <div className="hero-section-title text-center">
    //           <h1>{title}</h1>
    //         </div>
    //       </div>
    //       {posts.map(({ image, icon, title, text, button }, index) => (
    //         <div className="col-lg-4 col-md-6" key={`service-one-key-${index}`}>
    //           <div className="service_box">
    //             <div className="service_img">
    //               <Img src={image} alt="service 1" className="img-fluid" />
    //             </div>
    //             <div className="service_details">
    //               <Link href={button.url}>
    //                 <h2>{title}</h2>
    //               </Link>
    //               <p>{text}</p>
    //               <Link href={button.url} className="btn-blue">
    //                 {button.label}
    //               </Link>
    //             </div>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </section>
  );
};

export default ServiceOne;
